"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { createContext, useContext, useMemo, useState } from "react"

export type LayoutContextValue = {
  isSearchLoading: boolean
  updateSearchLoadingStatus: (property: LayoutContextValue["isSearchLoading"]) => void
}

const defaultValue = {
  isSearchLoading: false,
  updateSearchLoadingStatus: () => {},
}

const LayoutContext = createContext<LayoutContextValue>(defaultValue)

export const useLayoutContext = (): LayoutContextValue => useContext(LayoutContext)

type LayoutContextProviderProps = PropsWithChildren<{
  value?: LayoutContextValue
}>

export const LayoutContextProvider: FunctionComponent<LayoutContextProviderProps> = ({
  children,
  value = defaultValue,
}) => {
  const [isSearchLoading, updateSearchLoadingStatus] = useState<LayoutContextValue["isSearchLoading"]>(
    value.isSearchLoading
  )

  const contextValue = useMemo(
    () => ({
      ...value,
      isSearchLoading,
      updateSearchLoadingStatus,
    }),
    [isSearchLoading, updateSearchLoadingStatus, value]
  )

  return <LayoutContext.Provider value={contextValue}>{children}</LayoutContext.Provider>
}
